import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import CommonHeader from '../components/Headers/CommonHeader';

function NotFoundContent() {
  return (
    <div>
      <Helmet>
        <title>DISGENET: 404 - Page Not Found</title>
        <meta name="description" content="The page you are looking for does not exist." />
      </Helmet>
      <CommonHeader />
      <div className="notFoundPage">
        <h1>404</h1>
        <h2>This Page Not Found</h2>
        <p>
          Please return to <Link to="/">Home</Link>
        </p>
      </div>
    </div>
  );
}

export default NotFoundContent;
